import {Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {TenderDetailResponse} from '@frontend/shared-api';
import {SubsectionTitleComponent} from '../../../../../shared/components/header/subsection-title/subsection-title.component';

@Component({
  selector: 'app-tender-project-description',
  imports: [TranslocoPipe, SubsectionTitleComponent],
  templateUrl: './tender-description.component.html',
})
export class TenderDescriptionComponent {
  readonly tenderDetails = input.required<TenderDetailResponse>();
}
